// extracted by mini-css-extract-plugin
module.exports = {"section":"faq-section_section__s8FqK","title":"faq-section_title__b3V5k","allLink":"faq-section_allLink__tzj2c","list":"faq-section_list__B_5T8"};